import { useEffect } from 'react';

/**
 * A care home's colour as the accent — RX-ORG-11.
 *
 * The colour was validated against the light theme and its dark shade
 * derived on the server, then shown nowhere. This applies both, one per
 * theme, while the component using it is mounted, and puts the app's own
 * green back when it is not. Colours are re-checked here as `#RRGGBB`,
 * because this writes them into a stylesheet.
 */
const HEX = /^#[0-9a-fA-F]{6}$/;

export function useBrandAccent(light: string | null | undefined, dark: string | null | undefined): void {
  useEffect(() => {
    if (!light || !HEX.test(light)) return;
    const darkShade = dark && HEX.test(dark) ? dark : light;
    const style = document.createElement('style');
    style.dataset.rxBrand = '';
    // `html:root` outranks the apps' own `:root[data-theme]` rules.
    style.textContent =
      `html:root[data-theme="light"]{--accent:${light}}` +
      `html:root[data-theme="dark"]{--accent:${darkShade}}`;
    document.head.appendChild(style);
    return () => {
      style.remove();
    };
  }, [light, dark]);
}
